export const existingMobilePhoneErrorMessage = 'User with this mobile phone already exists.';
